import { forwardRef } from 'react';
import { AddBox, ArrowUpward, Check, ChevronLeft, ChevronRight, Clear, DeleteOutlineOutlined, Edit, FilterList, FirstPage, LastPage, Search } from '@mui/icons-material';

const icon = (Component) => forwardRef((props, ref) => <Component {...props} ref={ref} />);

const tableIcons = {
  Add: icon(AddBox),
  Check: icon(Check),
  Clear: icon(Clear),
  Delete: icon(DeleteOutlineOutlined),
  Edit: icon(Edit),
  Filter: icon(FilterList),
  FirstPage: icon(FirstPage),
  LastPage: icon(LastPage),
  NextPage: icon(ChevronRight),
  PreviousPage: icon(ChevronLeft),
  Search: icon(Search),
  SortArrow: icon(ArrowUpward)
};

export default tableIcons;